import React, { Component, } from 'react';
import {Modal, ModalHeader, ModalBody, Card, CardBody, Button} from 'reactstrap';
import { TabPanel } from "react-headless-tabs";
import {Row, Col} from "reactstrap";

const translator = require('../../../../utils/translator/translator');
const terminalUtility = require('../../../../utils/domain/terminalUtility');
const commonUtility = require('../../../../utils/domain/commonUtility');
const storefrontUtility = require('../../../../utils/domain/storefrontUtility');
const staffUtility = require('../../../../utils/domain/staff/staffUtility');
const saleCalculator = require('../../../../utils/domain/sales/saleCalculator');
const stringUtil = require('../../../../utils/string/stringUtil');
const dateUtil = require('../../../../utils/dateUtil/dateUtil');
const formatter = require('../../../../utils/formatter/formatter');
const localizationUtils = require('../../../../utils/domain/localizationUtils');

class Info extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.tabs = [];
        this.state.tabs.push("summary_overview");
        this.state.tabs.push("discounts");
        this.state.tabs.push("charges");
        this.state.tabs.push("refunds");
        this.state.tabs.push("receipt_lines");
        this.state.tabs.push("dispatch");
        this.state.selectedTab = this.state.tabs[0];
    }


    render()
    {
        return <Modal isOpen={true} backdrop={true} animation={false} fade={false} style={{minWidth:'80vw'}}>
                    <ModalHeader
                        close={
                            <div>
                                <Button className="btn-cancel" onClick={this.props.onClose}>{translator.getLabel("cancel")}</Button>
                            </div>
                        }
                    >
                        <span className="window-title">{translator.getLabel("order_details")}</span>
                    </ModalHeader>

                    <ModalBody>
                        <div className='h-100'>
                            <nav style={{
                                position: "relative",
                                border: "1px solid #05149e"
                                }}>

                                    <div style={{display:'flex', overflowX:'auto', maxWidth:'80vw'}}>
                                        {this.state.tabs.map((item) => {
                                            return (
                                            <span
                                                style={{
                                                flexGrow: 1,
                                                display: "block",
                                                padding: "1rem",
                                                textDecoration: "none",
                                                textAlign: 'center',
                                                color: this.state.selectedTab === item ? "white" : "var(--colors-primary)",
                                                background: this.state.selectedTab === item ? "var(--colors-primary)" : "var(--background-color)",
                                                borderRight: '1px solid var(--colors-primary)',
                                                cursor:'pointer'
                                                }}
                                                onClick={()=>
                                                {
                                                    this.state.selectedTab = item;
                                                    this.setState({});
                                                }}
                                            >
                                                {translator.getLabel(item)}
                                            </span>
                                            );
                                        })}
                                    </div>
                            </nav>
                            <TabPanel>
                                {this.getTabPanel()}
                            </TabPanel>
                        </div>
                    </ModalBody>
                </Modal>
    }

    getTabPanel()
    {
        var component = null;
        if (this.state.selectedTab == this.state.tabs[0])
            component = this.getSummaryTab();
        if (this.state.selectedTab == this.state.tabs[1])
            component = this.getDiscountsTab();
        if (this.state.selectedTab == this.state.tabs[2])
            component = this.getChargesTab();
        if (this.state.selectedTab == this.state.tabs[3])
            component = this.getRefundsTab();
        if (this.state.selectedTab == this.state.tabs[4])
            component = this.getReceiptLinesTab();
        if (this.state.selectedTab == this.state.tabs[5])
            component = this.getTimingsTab();
      
        return <div style={{height:'70vh', overflowY:'auto', padding:'20px'}}>
                    {component}
                </div>
    }

    getSummaryTab()
    {
        let sale = this.props.sale;

        let saleDateTime = "NA";
        if (!stringUtil.isStringNullOrEmpty(sale.dateTime))
            saleDateTime = dateUtil.convertToLocalStandard(sale.dateTime);

        let storefrontName = "";
        let storefrontId = "";

        if (!stringUtil.isStringNullOrEmpty(sale.storefrontId))
        {
            let storefront = storefrontUtility.getStorefrontById(sale.storefrontId);
            if (storefront != null)
            {
                storefrontName = storefront.name;
                storefrontId = storefront.id;
            }
        }

        let linkedTables = "";
        if (sale.linkedTables != null)
            linkedTables = sale.linkedTables.join(",")

        let terminalCode = "";
        let terminalId = "";
        let terminal = terminalUtility.getTerminalById(sale.terminalId);
        if (terminal != null)
        {
            terminalCode = terminal.code;
            terminalId = terminal.id;
        }

        let attributes = [];
        attributes.push(this.getAttribute(translator.getLabel("number"), sale.number))
        attributes.push(this.getAttribute(translator.getLabel("id"), sale.id))
        attributes.push(this.getAttribute(translator.getLabel("date"), saleDateTime))
        attributes.push(this.getAttribute(translator.getLabel("type"), sale.saleType))
        attributes.push(this.getAttribute(translator.getLabel("dispatch"), sale.dispatchType))
        attributes.push(this.getAttribute(translator.getLabel("venue"), sale.venueCode))
        attributes.push(this.getAttribute(translator.getLabel("instructions"), sale.instructions))

        if (sale.isCancelled)
        {
            attributes.push(this.getAttribute(translator.getLabel("is_cancelled"), "True"))
            attributes.push(this.getAttribute(translator.getLabel("cancellation_reasons"), sale.cancellationReason))
            attributes.push(this.getAttribute(translator.getLabel("cancelled_by"), sale.cancelledBy))
        }

        attributes.push(this.getAttribute(translator.getLabel("operator"), sale.operator))
        attributes.push(this.getAttribute(translator.getLabel("server"), sale.server))
        if (!stringUtil.isStringNullOrEmpty(sale.driverId))
        {
            attributes.push(this.getAttribute(translator.getLabel("driver_id"), sale.driverId));
            let driverStaff = staffUtility.getStaffById(sale.driverId);
            if (driverStaff != null)
            {
                attributes.push(this.getAttribute(translator.getLabel("driver"), staffUtility.getStaffCompleteName(driverStaff)));
            }
        }
        
        attributes.push(this.getAttribute(translator.getLabel("covers"), sale.noOfGuests))
        attributes.push(this.getAttribute(translator.getLabel("table_number"), sale.tableNumber))
        attributes.push(this.getAttribute(translator.getLabel("joined_tables"), linkedTables))
        attributes.push(this.getAttribute(translator.getLabel("total_order_price"), formatter.convertToCurrencyFormat(saleCalculator.calculateTotalOrderPrice(sale))))
        attributes.push(this.getAttribute(translator.getLabel("total_discounts"), formatter.convertToCurrencyFormat(saleCalculator.calculateTotalDiscounts(sale))))
        attributes.push(this.getAttribute(translator.getLabel("total_charges"), formatter.convertToCurrencyFormat(saleCalculator.calculateTotalCharges(sale))))
        attributes.push(this.getAttribute(translator.getLabel("total_vat"), formatter.convertToCurrencyFormat(saleCalculator.calculateTotalVAT(sale))))
        attributes.push(this.getAttribute(translator.getLabel("vat_is_inclusive"), localizationUtils.isVatInclusive().toString()))
        attributes.push(this.getAttribute(translator.getLabel("total_sale_price"), formatter.convertToCurrencyFormat(saleCalculator.calculateTotalSalePrice(sale))))
        attributes.push(this.getAttribute(translator.getLabel("total_paid_amount"), formatter.convertToCurrencyFormat(sale.paidAmount ?? 0)))
        attributes.push(this.getAttribute(translator.getLabel("total_payable"), formatter.convertToCurrencyFormat(saleCalculator.calculateRemainingPayableAmount(sale))))
        attributes.push(this.getAttribute(translator.getLabel("payment_method"), sale.paymentMethod))
        attributes.push(this.getAttribute(translator.getLabel("customer_id"), sale.customerId))
        attributes.push(this.getAttribute(translator.getLabel("terminal_code"), terminalCode))
        attributes.push(this.getAttribute(translator.getLabel("terminal_id"), terminalId))
        attributes.push(this.getAttribute(translator.getLabel("storefront_name"), storefrontName))
        attributes.push(this.getAttribute(translator.getLabel("storefront_id"), storefrontId))

        return this.getAttributesComponent(attributes);
    }

    getDiscountsTab()
    {
        let sale = this.props.sale;

        if (sale.discounts == null || sale.discounts.length <= 0)
        {
            return <div className='d-flex justify-content-center align-items-center'>{translator.getLabel("no_discounts_found")}</div>
        }

        let attributes = [];
        sale.discounts.forEach (discount =>
        {
            attributes.push(this.getAttribute(discount.type, formatter.convertToCurrencyFormat(discount.amount)))  
        })

        return this.getAttributesComponent(attributes);
    }

    getChargesTab()
    {
        let sale = this.props.sale;

        if (sale.charges == null || sale.charges.length <= 0)
        {
            return <div className='d-flex justify-content-center align-items-center'>{translator.getLabel("no_charges_found")}</div>
        }

        let attributes = [];
        sale.charges.forEach (charge =>
        {
            attributes.push(this.getAttribute(charge.type, formatter.convertToCurrencyFormat(charge.amount)))  
        })

        return this.getAttributesComponent(attributes);
    }

    getRefundsTab()
    {
        let sale = this.props.sale;

        if (sale.refunds == null || sale.refunds.length <= 0)
        {
            return <div className='d-flex justify-content-center align-items-center'>{translator.getLabel("no_refunds_found")}</div>
        }

        let attributes = [];
        sale.refunds.forEach (refund =>
        {
            attributes.push(this.getAttribute(`${refund.refundCode} (${refund.operator})`, formatter.convertToCurrencyFormat(refund.refundAmount)))  
        })

        return this.getAttributesComponent(attributes);
    }

    getReceiptLinesTab()
    {
        let sale = this.props.sale;

        if (sale.receiptLines == null || sale.receiptLines.length <= 0)
        {
            return <div className='d-flex justify-content-center align-items-center'>{translator.getLabel("no_receipt_lines_found")}</div>
        }

        let attributes = [];
        sale.receiptLines.forEach (receiptLine =>
        {
            attributes.push(this.getAttribute(`${receiptLine.type}`, receiptLine.line))  
        })

        return this.getAttributesComponent(attributes);
    }

    getTimingsTab()
    {
        let sale = this.props.sale;

        let saleDateTime = "NA";
        var originalPlannedDispatchDateTime = "N/A";
        var actualDispatchDateTime = "N/A";
        var finalStationCompletionDateTime = "N/A";

        if (!stringUtil.isStringNullOrEmpty(sale.dateTime))
            saleDateTime = dateUtil.convertToLocalStandard(sale.dateTime);

        if (!stringUtil.isStringNullOrEmpty(sale.originalPlannedDispatchDateTime))
            originalPlannedDispatchDateTime = dateUtil.convertToLocalStandard(sale.originalPlannedDispatchDateTime);

        if (!stringUtil.isStringNullOrEmpty(sale.finalStationCompletionDateTime))
            finalStationCompletionDateTime = dateUtil.convertToLocalStandard(sale.finalStationCompletionDateTime);

        if (!stringUtil.isStringNullOrEmpty(sale.actualDispatchDateTime))
            actualDispatchDateTime = dateUtil.convertToLocalStandard(sale.actualDispatchDateTime);
     
        

        let attributes = [];
        attributes.push(this.getAttribute(translator.getLabel("sale_time"), saleDateTime))
        attributes.push(this.getAttribute(translator.getLabel("expected_dispatch_time"), originalPlannedDispatchDateTime))
        attributes.push(this.getAttribute(translator.getLabel("kitchen_prep_time"), finalStationCompletionDateTime))
        attributes.push(this.getAttribute(translator.getLabel("actual_dispatch_time"), actualDispatchDateTime))
        var timingsComponent = this.getAttributesComponent(attributes);

        attributes = [];

        if (sale.dispatchInfo == null)
            return timingsComponent;

        var dispatchInfo = JSON.parse(sale.dispatchInfo);
        
        attributes = [];
        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.customerName))
        {
            attributes.push(this.getAttribute(translator.getLabel("venue_dialogue_customer_name"), dispatchInfo.customerName))
        }
        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.customerPhoneNumber))
        {
            attributes.push(this.getAttribute(translator.getLabel("venue_dialogue_customer_phone_number"), dispatchInfo.customerPhoneNumber))
        }
        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.customerRating))
        {
            attributes.push(this.getAttribute(translator.getLabel("customer_rating"), `${dispatchInfo.customerRating} stars`))
        }
        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.deliveryAddress))
        {
            attributes.push(this.getAttribute(translator.getLabel("venue_dialogue_customer_delivery_address"), dispatchInfo.deliveryAddress))
        }
        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.distance))
        {
            attributes.push(this.getAttribute(translator.getLabel("delivery_distance"), `${dispatchInfo.distance} ${commonUtility.getDistanceMeasurementUnit()}`))
        }

        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.guestName))
        {
            attributes.push(this.getAttribute(translator.getLabel("guest_name"), dispatchInfo.guestName))
        }

        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.freebiesReason))
        {
            attributes.push(this.getAttribute(translator.getLabel("freebies_reason"), dispatchInfo.freebiesReason))
        }

        if (!stringUtil.isStringNullOrEmpty(dispatchInfo.dispatchType))
        {
            attributes.push(this.getAttribute(translator.getLabel("venue_dialogue_dispatch_type"), dispatchInfo.dispatchType))
        }


        var dispatchComponent = this.getAttributesComponent(attributes);

        return <div>
                    <div>{timingsComponent}</div>
                    <div style={{marginTop:'40px'}}>{dispatchComponent}</div>
                </div>
    }

    getAttribute(name, value)
    {
        if (stringUtil.isStringNullOrEmpty(value) || 
            stringUtil.areStringSame(value, "NA") ||
            stringUtil.areStringSame(value, "N/A"))
            value = translator.getLabel("not_available");

        return {name, value}
    }

    getAttributesComponent(attributes)
    {
        let background = "#E8E8E8";
        let components = [];
        
        attributes.forEach (attribute =>
        {
            components.push(<Row style={{background:background}}>
                                <Col md={3} style={{border:'1px solid #B8B8B8', padding:'10px'}}>
                                    <div style={{wordBreak:'break-word', userSelect:'all'}}>{attribute.name}</div>
                                </Col>
                                <Col md={9} style={{border:'1px solid #B8B8B8', padding:'10px'}}>
                                    <div style={{wordBreak:'break-word', userSelect:'all'}}>{attribute.value}</div>
                                </Col>
                            </Row>);

            background = background == "#E8E8E8" ? "#F8F8F8" : "#E8E8E8"
        });

        return <div>
                    {components}
               </div>
    }
    
}

export default Info;